import React, { FC } from 'react';
import Badge from 'react-bootstrap/Badge';
import styled from 'styled-components';

export interface IProps {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'light' | 'dark';
  label?: string;
  normalBadgeStyles?: boolean;
}

const BadgeComponent: FC<IProps> = ({ variant, label, normalBadgeStyles }: IProps) => {
  return (
    <StyledBadge
      pill
      variant={variant}
      normalBadgeStyles={normalBadgeStyles}
    >
      {label}
    </StyledBadge>
  );
};

const StyledBadge = styled(Badge)`
  font-weight: ${props => (props.normalBadgeStyles ? '400' : '500')};
  font-size: ${props => (props.normalBadgeStyles ? '14px' : '80%')};
`;

export default BadgeComponent;
